/**
 * @generated SignedSource<<2c672c861ce7db128b20f6df4e8e1e00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CostSettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "CostSettingsPage_query";
};
export type CostSettingsPage_query$key = {
  readonly " $data"?: CostSettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"CostSettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CostSettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d31053de371971841d29d51449852f96";

export default node;
